import {AddNode} from './AddNode';
import {NODE_ROLES} from '../../const';

class AddGeneric extends AddNode {
  icon = 'server';
  tooltip = 'Add Generic Server';

  onClick = () => {
    this.createNode(NODE_ROLES.GENERIC);
  };
}

export {AddGeneric};
